<span [dsMarkdown]="value"></span>
